module.exports = __webpack_public_path__ + "static/media/solution-decor2.f1676589.png";